// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '../../../../../../node_module_clones/recompose';
import { createStructuredSelector } from 'reselect';

// Selectors
import popupOpenSelector from '../../../../../components/popupPanel/popupOpenSelector';
import { getIsElectronSelector } from '../../../../../components/electron/electronSelector';

// Components
import booleanPropRatchet from '../../../../../utils/milanoteRecompose/booleanPropRatchet';
import PopupPanel from '../../../../../components/popupPanel/PopupPanel';
import { ElectronUpdateStatus } from './ElectronUpdateStatus';

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

// Styles
import './ElectronAppUpdateRequiredPopup.scss';

export const ELECTRON_UPDATE_REQUIRED_POPUP_NAME = PopupIds.ELECTRON_UPDATE_REQUIRED;

const mapStateToProps = createStructuredSelector({
    popupOpen: popupOpenSelector(ELECTRON_UPDATE_REQUIRED_POPUP_NAME),
    isElectron: getIsElectronSelector,
});

const enhance = compose(connect(mapStateToProps), booleanPropRatchet('popupOpen'));

const ElectronAppUpdateRequiredPopup = (props) => {
    const { popupOpen, isElectron } = props;

    if (!isElectron) return null;

    // FIXME Get appropriate image
    return (
        <PopupPanel
            {...props}
            className="ElectronAppUpdateRequiredPopup"
            popupId={ELECTRON_UPDATE_REQUIRED_POPUP_NAME}
            forceVisible={popupOpen}
            stayOpen
        >
            <div className="warning-content">
                <div className="illustration-container">
                    <img className="illustration" src={require('./update-app@2x.png')} />
                </div>
                <div className="body">
                    <h3>Your Milanote version is too old</h3>

                    <p>
                        To ensure you get the latest features and avoid unexpected bugs you must update your Milanote
                        application.
                    </p>

                    <div className="update-status-container">
                        <ElectronUpdateStatus />
                    </div>
                </div>
            </div>
        </PopupPanel>
    );
};

ElectronAppUpdateRequiredPopup.propTypes = {
    popupOpen: PropTypes.bool,
    isElectron: PropTypes.bool,
};

export default enhance(ElectronAppUpdateRequiredPopup);
